import { forwardRef } from 'react'
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@cocoonspace/ui/components/select'

const formatDurationLabel = (minutes: number): string => {
	if (minutes === 30) {
		return '30min'
	}
	const hours = Math.floor(minutes / 60)
	const remainingMinutes = minutes % 60
	if (remainingMinutes === 0) {
		return `${hours}h`
	}
	return `${hours}h${remainingMinutes}`
}

const durations = Array.from({ length: 24 }, (_, i) => {
	const minutes = (i + 1) * 30
	return {
		label: formatDurationLabel(minutes),
		value: minutes,
	}
})

export const DurationSelect = forwardRef<
	HTMLButtonElement,
	{
		value?: number
		onChange: (value?: number) => void
	}
>(({ value, onChange }, ref) => (
	<Select
		onValueChange={(value) => onChange(Number(value))}
		value={value?.toString()}
	>
		<SelectTrigger
			ref={ref}
			inputSize='sm'
		>
			<SelectValue />
		</SelectTrigger>

		<SelectContent onWheel={(e) => e.stopPropagation()}>
			{durations.map((duration) => (
				<SelectItem
					key={duration.value}
					value={duration.value.toString()}
				>
					{duration.label}
				</SelectItem>
			))}
		</SelectContent>
	</Select>
))
